import { TYPE_COLLECTION } from '../input-types';

export const id = 'orderStatus';
export const apiKey = 'OrderGridStatus';
export const type = TYPE_COLLECTION;

export const orderStatus = {
  id,
  apiKey,
  type,
};
